export default __webpack_public_path__ + "static/media/img5.3a85248e.jpg";